/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Realtime_DependsInputs */

const fr_help_realtime_depends = /** @type {(inputs: Help_Realtime_DependsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le temps réel dépend intégralement du bon vouloir des réseaux et de la qualité technique de leurs flux de données.`)
};

const en_help_realtime_depends = /** @type {(inputs: Help_Realtime_DependsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real-time data depends entirely on each network's willingness to publish it and on the technical quality of their data feeds.`)
};

/**
* | output |
* | --- |
* | "Real-time data depends entirely on each network's willingness to publish it and on the technical quality of their data feeds." |
*
* @param {Help_Realtime_DependsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_realtime_depends = /** @type {((inputs?: Help_Realtime_DependsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Realtime_DependsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_realtime_depends(inputs)
	return en_help_realtime_depends(inputs)
});